import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ["description", "form", "input"];

  toggleCheckbox(event) {
    if (!this.hasInputTarget) {
      console.error("No input target found");
      return;
    }

    const checkboxInput = event.target;
    const originalText = decodeURIComponent(checkboxInput.dataset.originalText);
    const checkboxIndex = parseInt(checkboxInput.dataset.checkboxIndex);
    const description = this.inputTarget.value;

    console.log("Current state:", {
      originalText,
      checkboxIndex,
      description,
      checked: checkboxInput.checked,
    });

    // Find the nth occurrence of the checkbox pattern
    let count = 0;
    const checkboxPattern = /\[([ x])\]/gi;
    const newText = description.replace(checkboxPattern, (match) => {
      count++;
      if (count === checkboxIndex) {
        return checkboxInput.checked ? "[x]" : "[ ]";
      }
      return match;
    });

    console.log("New text:", newText);

    // Create and submit form data
    const formData = new FormData();
    const modelName = this.formTarget
      .querySelector("textarea")
      .name.split("[")[0];
    formData.append(`${modelName}[content]`, newText);
    formData.append(
      `${modelName}[id]`,
      this.formTarget.querySelector('input[type="hidden"]').value,
    );

    const updateUrl = this.formTarget.dataset.noteCheckboxUrlValue;

    fetch(updateUrl, {
      method: "PATCH",
      body: formData,
      headers: {
        Accept: "text/vnd.turbo-stream.html, text/html, application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
    })
      .then((response) => response.text())
      .then((html) => {
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => console.error("Error updating checkbox:", error));
  }

  escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
}
